export default __webpack_public_path__ + "static/media/graphic-guards-protector.6d61beb9.jpg";